import { render, staticRenderFns } from "./CredentialStorageSave.vue?vue&type=template&id=07b49c57&scoped=true&"
import script from "./CredentialStorageSave.vue?vue&type=script&lang=js&"
export * from "./CredentialStorageSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b49c57",
  null
  
)

export default component.exports